export enum PageOptions {
  EDIT,
  VIEW,
  CREATE,
  WAIT,
}
